module.exports = __webpack_public_path__ + "static/media/social_good.cbb9c861.jpg";